const MedicalRecordDetailReportWeb = () => {
  return <></>;
};

export default MedicalRecordDetailReportWeb;
